import { StatisticsApi } from '@hefe/store';
import ChartPickerComponent from '../chart-picker/chart-picker.component';

interface BasketballPracticesStatisticsComponentProps {
  from: string;
  till: string;
}

export default function BasketballPracticesStatisticsComponent(
  props: BasketballPracticesStatisticsComponentProps
) {
  const { data, isFetching } =
    StatisticsApi.useFetchBasketballPracticesStatisticsQuery({
      from: props.from,
      till: props.till,
    });

  return <ChartPickerComponent charts={data ?? []} loading={isFetching} />;
}
